module.exports = __webpack_public_path__ + "img/Lab_Book_Icon_Paste.c08ceb4b.svg";